import { 
    ADD_ALERT,
    CREATE_PROFORMA_INVOICE,
    FETCH_ALL_FINAL_INVOICES,
    FETCH_INVOICE_PATH,
    DELETE_FINAL_INVOICE
} from './types';
import shortId from "shortid";
import sleektrading from "../apis/sleektrading"

export const fetchAllFinalInvoices= (pageNumber) => async dispatch => {
    const {data} = await sleektrading.post(`/final_invoices/index?page=${pageNumber}`);
    
    if(data.code == 201){
        dispatch({
            type: FETCH_ALL_FINAL_INVOICES,
            payload: data.data
        });
    }
}

export const printInvoice = (params) => dispatch => {
    const config = { responseType: 'blob', Accept:'application/pdf' };   
    sleektrading.post('/final_invoices/print', params, config)
    .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const date = new Date().getTime()+'finalinvoic.pdf';
        link.setAttribute('download', date);
        document.body.appendChild(link);
        link.click();
        const blob = new Blob([response.data], {
            type: "application/pdf",
        });
    });
}

export const deleteInvoice= (invoice_id) => async dispatch => {
    sleektrading.post('/final_invoices/delete', {invoice_id})
    .then(response => {
        if(response.data.code == 200) {
            dispatch({
                type:DELETE_FINAL_INVOICE, 
                payload:invoice_id
            });
            dispatch({
                type: ADD_ALERT,
                payload: {
                    key: shortId.generate(),
                    status: 'success',
                    color:'info',
                    message: response.data.message,
                    errors: {}
                }
            });
        } else {
            dispatch({
                type: ADD_ALERT,
                payload: {
                    key: shortId.generate(),
                    status: 'success',
                    color:'info',
                    message: response.data.message,
                    errors: {}
                }
            });
        }
    }).catch(error => {
        dispatch({
            type:ADD_ALERT,
            payload:{
            key:shortId.generate(),
            status:'error',
            message:error.response.data.message,
            errors:error.response.data.errors
        }
    });
    });
}



